import type { Lang } from '../i18n'

const LOCALE: Record<Lang, string> = { en: 'en-US', ru: 'ru-RU', uk: 'uk-UA' }

/** A share link's dates: the expiry line, the dialog's rows. */
export function shareDate(at: string, lang: Lang): string {
  return new Intl.DateTimeFormat(LOCALE[lang], { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(at))
}

/** A day and a short month, with no year: the paused mark's date (GRO-176). */
export function dayMonth(at: string, lang: Lang): string {
  return new Intl.DateTimeFormat(LOCALE[lang], { day: 'numeric', month: 'short' }).format(new Date(at))
}
